import React from 'react';
import Select from 'react-select';
import selectStyles from './selectStyles';
import DropdownIndicator from './components/dropdownIndicator';

const SelectDropdown = ({ value, ...rest }) => {
    const getOptionLabel = o => o.label || o[rest.labelKey];
    const getOptionValue = o => o.value || o[rest.valueKey];
    const selectedValue = typeof value === 'object'
        ? value
        : rest.options && rest.options.find(x => x.value === value || getOptionValue(x) === value) || null;

    const IndicatorSeparator = () => null;
    return (
        <Select
            {...rest}
            className={`Select ${rest.className || ''}`}
            components={{ DropdownIndicator, IndicatorSeparator }}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            isClearable={rest.clearable !== undefined ? rest.clearable : true}
            isDisabled={rest.disabled !== undefined ? rest.disabled : false}
            isSearchable={rest.searchable !== undefined ? rest.searchable : true}
            styles={selectStyles}
            value={selectedValue}
        />
    );
};

export default SelectDropdown;